import { useState, useRef, useEffect, useCallback } from 'react';
import { Info } from 'lucide-react';

export default function InfoTooltip({ text, size = 14, className = '' }) {
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState('below');
  const ref = useRef(null);
  const btnRef = useRef(null);

  const calcPosition = useCallback(() => {
    if (!btnRef.current) return;
    const rect = btnRef.current.getBoundingClientRect();
    // If less than 80px above, show below
    setPosition(rect.top < 80 ? 'below' : 'above');
  }, []);

  useEffect(() => {
    if (!open) return;
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const show = () => {
    calcPosition();
    setOpen(true);
  };

  return (
    <span ref={ref} className={`relative inline-flex ${className}`}>
      <button
        ref={btnRef}
        type="button"
        onClick={(e) => { e.stopPropagation(); open ? setOpen(false) : show(); }}
        onMouseEnter={show}
        onMouseLeave={() => setOpen(false)}
        className="text-gray-400 dark:text-gray-500 hover:text-brand-500 dark:hover:text-brand-400 transition-colors focus:outline-none"
        aria-label="Info"
      >
        <Info size={size} />
      </button>
      {open && (
        <div className={`absolute z-50 left-1/2 -translate-x-1/2 w-56 px-3 py-2 text-xs text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg animate-fade-in ${
          position === 'above' ? 'bottom-full mb-2' : 'top-full mt-2'
        }`}>
          {text}
          {/* Arrow */}
          <div className={`absolute left-1/2 -translate-x-1/2 ${
            position === 'above' ? 'top-full -mt-px' : 'bottom-full -mb-px'
          }`}>
            <div className={`w-2 h-2 rotate-45 bg-white dark:bg-gray-800 ${
              position === 'above'
                ? 'border-r border-b border-gray-200 dark:border-gray-700'
                : 'border-l border-t border-gray-200 dark:border-gray-700'
            }`} />
          </div>
        </div>
      )}
    </span>
  );
}
